import React, { useEffect, useState } from "react";
import { getAuth, applyActionCode } from "firebase/auth";
import EmailVerificationNotice from "../EmailVerificationNotice";

/**
 * VerifyEmail page:
 * - If the URL includes oobCode -> applyActionCode to confirm verification.
 * - Otherwise shows EmailVerificationNotice (instructions).
 */
export default function VerifyEmail() {
  const [status, setStatus] = useState({ loading: true, message: null });
  const auth = getAuth();

  useEffect(() => {
    async function verify() {
      const params = new URLSearchParams(window.location.search);
      const oobCode = params.get("oobCode");

      if (!oobCode) {
        setStatus({ loading: false, message: null });
        return;
      }

      try {
        await applyActionCode(auth, oobCode);
        setStatus({ loading: false, message: "Tu correo ha sido verificado correctamente. Ya podés ingresar." });
      } catch (err) {
        console.error("applyActionCode error:", err);
        const msg = err && err.code
          ? (err.code === "auth/expired-action-code" ? "El enlace expiró." : (err.code === "auth/invalid-action-code" ? "El enlace no es válido." : err.message))
          : "Error verificando el correo.";
        setStatus({ loading: false, message: msg });
      }
    }
    verify();
  }, [auth]);

  return (
    <div style={{ maxWidth: 640, margin: "24px auto" }}>
      <h2>Verificación de correo</h2>
      {status.loading && <p>Verificando...</p>}
      {!status.loading && status.message && <p>{status.message}</p>}
      {!status.loading && !status.message && <EmailVerificationNotice />}
      <div style={{ marginTop: 12 }}>
        <a href="/login">Ir a iniciar sesión</a>
      </div>
    </div>
  );
}